import api from "./api";

class TipologiaContabilitaManager {

    tipologie(config?: any) {
        return api.get(`/tipologia_contabilita`, config)
    }

    tipologia(id:string|number, config?: any) {
        return api.get(`/tipologia_contabilita/${id}/`, config)
    }

    retrieve = this.tipologia
    list = this.tipologie
    paginatedList = this.tipologie
}

const tipologiaContabilitaManager = new TipologiaContabilitaManager()

export default tipologiaContabilitaManager
